import React from 'react';
import ProductModal from './ProductModal';
import CarouselEmbla from './CarouselEmbla';

let productsCache = null;
async function loadProducts() {
  if (productsCache) return productsCache;
  const res = await fetch('/data/products.json');
  const data = await res.json();
  productsCache = data;
  return data;
}

function formatArPrice(value) {
  if (value == null) return '$0';

  const formatOne = (val) => {
    let num;
    if (typeof val === 'string') {
      let normalized = val.replace(/[^0-9.,]/g, '');
      if (normalized.includes(',') && normalized.includes('.')) {
        normalized = normalized.replace(/\./g, '').replace(',', '.');
      } else if (normalized.includes(',') && !normalized.includes('.')) {
        normalized = normalized.replace(',', '.');
      } else if (normalized.includes('.') && !normalized.includes(',')) {
        normalized = normalized.replace(/\./g, '');
      }
      num = Number(normalized);
    } else {
      num = Number(val);
    }
    if (!isFinite(num)) return '$0';
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(num);
  };

  // Arrays → múltiples precios
  if (Array.isArray(value)) {
    return value.map(formatOne).join(' | ');
  }
  // Cadena con separador "|" → múltiples precios
  if (typeof value === 'string' && value.includes('|')) {
    return value.split('|').map(s => formatOne(s.trim())).join(' | ');
  }

  return formatOne(value);
}

function Gallery({ category }) {
  const [data, setData] = React.useState(null);
  const [selected, setSelected] = React.useState(null);
  const [index, setIndex] = React.useState(0);
  const [sliding, setSliding] = React.useState(null);
  const [noAnim, setNoAnim] = React.useState(false);
  const [busy, setBusy] = React.useState(false);

  React.useEffect(() => {
    let mounted = true;
    loadProducts().then(d => { if (mounted) setData(d); });
    return () => { mounted = false; };
  }, []);

  const items = data && data[category] ? data[category] : [];

  const renderCard = (item) => {
    const price = formatArPrice(item.price);
    return (
      <figure
        className="tm-card"
        onClick={() => setSelected({ src: item.src, name: item.name || 'Producto', price, category })}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => { if (e.key === 'Enter') setSelected({ src: item.src, name: item.name || 'Producto', price, category }); }}
      >
        <div className="tm-card-body">
          <img src={item.src} alt={category} loading="lazy" />
        </div>
        <figcaption className="tm-card-info">
          <div className="tm-card-price">{price}</div>
        </figcaption>
      </figure>
    );
  };

  return (
    <>
      {items.length === 0 ? (
        <div className="tm-empty">No hay productos para esta categoría.</div>
      ) : (
        <CarouselEmbla items={items} renderItem={renderCard} />
      )}

      <ProductModal open={!!selected} product={selected} onClose={() => setSelected(null)} />
    </>
  );
}

export default Gallery;



